module.exports = __webpack_public_path__ + "img/donations_sign.bdfc636e.png";